import { createToken, refreshToken } from '@/api/auth';
// import { fetchSelf } from '@/api/member';
import { getToken, removeToken, setToken } from '@/common/token';
import { fetchSelf } from '@/api/member';
import { commonError } from '@/common/dialog';
import { fetchOtps } from '@/api/otp';
import { fetchMerchant } from '@/api/pg';

// import sio from '@/src/utils/sio';

export const state = {
	member_info: '',
	access_token: getToken() ? getToken() : '',
	otps: [],
	merchantInfo: {},
};

export const mutations = {
	SET_CURRENT_MEMBER(state, value) {
		state.member_info = value;
	},
	SET_ACCESS_TOKEN(state, value) {
		state.access_token = value;
		setToken(value);
	},
	SET_OTPS(state, newValue) {
		state.otps = newValue;
	},
	SET_MERCHANT_INFO(state, newValue) {
		state.merchantInfo = newValue;
	},
};

export const getters = {
	// Whether the user is currently logged in.
	member_info(state) {
		return state.member_info;
	},
	is_logged_in(state) {
		return !!state.access_token;
	},
	token(state) {
		return state.access_token;
	},
};

export const actions = {
	// This is automatically run in `src/state/store.js` when the app
	// starts, along with any other actions named `init` in other modules.
	init({ dispatch, getters }) {
		if (!getters.is_logged_in) return;
		dispatch('validate');
		dispatch('getOtps');
	},

	// Logs in the current user.
	async login({ commit, dispatch }, user) {
		const response = await createToken(user);
		if (response.otp_token_required) return response;
		//sio.emit('authenticate', { token });	// 소켓인증
		try {
			await commit('SET_ACCESS_TOKEN', response.token);
			await dispatch('validate');
		} catch (error) {
			// TODO ERROR HANDLE
			console.log(error);
			await commonError(error);
		}
	},

	async refreshToken({ commit, dispatch }) {
		try {
			const response = await refreshToken();
			if (response.otp_token_required) return response;
			//sio.emit('authenticate', { token });	// 소켓인증
			await commit('SET_ACCESS_TOKEN', response.token);
			await dispatch('validate');
		} catch (error) {
			// TODO ERROR HANDLE
			console.log(error);
			// await commonError(error);
			dispatch('logout');
		}
	},

	// Logs out the current user.
	logout({ commit }) {
		commit('SET_ACCESS_TOKEN', '');
		commit('SET_CURRENT_MEMBER', '');
		removeToken();
	},

	async getOtps({ commit }) {
		const { data } = await fetchOtps();
		commit('SET_OTPS', data);
	},

	async getMemberInfo({ commit }) {
		const { member_info } = await fetchSelf();
		commit('SET_CURRENT_MEMBER', member_info);
	},

	async getMerchantInfo({ commit }, seq) {
		const { merchant_info } = await fetchMerchant(seq);
		commit('SET_MERCHANT_INFO', merchant_info);
	},

	// Validates the current user's token and refreshes it
	// with new data from the API.
	async validate({ commit, getters }) {
		if (getters.is_logged_in) {
			if (state.member_info) return Promise.resolve(null);
			const response = await fetchSelf();
			try {
				commit('SET_CURRENT_MEMBER', response.member_info);
				return response.member_info;
			} catch (e) {
				commit('SET_CURRENT_MEMBER', null);
				return null;
			}
		}
	},
};
